export const VERIFICATION_ID_URL_KEY = 'verificationId';

//TODO: remove process.env.NEXT_PUBLIC_BFF_URL for server component;
export const API_URLS = {
  getDocumentList:
    '/api/validation/component-and-document-type?verificationRequestId=#{verificationRequestId}&claimId=#{claimId}',
  getDocumentListForCaseEntry:
    '/api/case-entry/component-and-document-type?verificationRequestId=#{verificationRequestId}&claimId=#{claimId}',

  getRBACPermissions: '/api/rbac/permissions',
  getRouteConfig: '/api/rbac/route-config',
  getDashboardNavItems: '/api/config/opsDashboardNavConfig',
  getLanguages: '/api/config/languages',
  getNationalityDetails: `/api/config/nationalities`,
  getMyDashboardDetails: `/api/dashboard-ops/details`,
  getActiveFeatureConfig: `/api/config/active-features`,
  getCurrencyDetails: `/api/config/allCurrency`,
  getAllCurrencyDetails: `/api/config/allCurrency`,
  getVendorDetail: '/api/vendor/details?vendorId=#{vendorId}',
  getEditVendorDetails: '/api/vendor/vendorDetails?vendorId=#{vendorId}',
  postVendorApprove: '/api/vendor/approve?vendorId=#{vendorId}',
  postVendorDeActivate: '/api/vendor/de-activate?vendorId=#{vendorId}',
  postVendorReject: '/api/vendor/reject?vendorId=#{vendorId}',
  postVendorAddTeamMember: '/api/vendor-team-member',
  getUserProfile: `/api/user`,
  getLegacyCaseAppealUrl:
    '/api/verification-modification/legacy-case-appeal-url?caseId=#{caseId}',
  getDashboardDetails: `/api/dashboard-ops/details?type=#{type}`,
  getDashboardAllocationDetails: `/api/dashboard-ops/allocation-details?stage=#{stage}`,
  getDashboardRedirectionDetails: `/api/dashboard-ops/dashboard-redirection-details?stage=#{stage}&caseId=#{caseId}`,
  getForceMajeureDetails: `/api/force-majeure?status=#{status}`,
  getVendorTaskDetails: `/api/vendor-task?from=#{from}&to=#{to}`,
  getVendorTaskDetailsPaginated: `/api/vendor-task`,
  getVendorTaskFilterOptions: `/api/vendor-task/filters`,
  getVendorTasksBySearchText: `/api/vendor-task/search?text=#{text}`,
  getVendorTaskDetailsCSVDownload: `/api/vendor-task/download-csv?from=#{from}&to=#{to}`,
  getAllVendors: `/api/vendor-task/allVendors?subType=#{subType}&taskId=#{taskId}`,
  cancelVendorTask: `/api/vendor-task/cancel?telescopicAccessType=#{telescopicAccessType}`,
  getReviewTasksDetails: `/api/dashboard-ops/review-tasks`,
  getFinanceTasksDetails: `/api/ia-payout/case?searchText=#{searchText}`,
  getApplicantDetails: `/api/validation/applicant-details?caseId=#{caseId}&followUpType=#{followUpType}`,
  getVerificationDetailsByToken: `/api/validation/applicant-details?token=#{token}`,
  getAppealErrorDetails: `/api/appeal-error-details?caseId=#{caseId}`,
  getApplicantFollowupDetails: `/api/applicant-followup?caseId=#{caseId}`,
  updateApplicantFollowupDetails: `/api/applicant-followup?caseId=#{caseId}`,
  updateAppealErrorDetails: `/api/appeal-error-details/update`,
  getReviewTaskDetails: `/api/dashboard-ops/review-task`,

  getClientContractDetails:
    '/api/client-contract/details?clientContractId=#{clientContractId}',
  getClientContractComponents:
    '/api/client-contract/components?clientContractId=#{clientContractId}',
  getReportTransferConfig:
    '/api/client-contract/report-transfer-config?clientContractId=#{clientContractId}',
  getClientContractPrice:
    '/api/client-contract/price?clientContractId=#{clientContractId}',
  getOtherConfigDetails:
    '/api/client-contract/other-config?clientContractId=#{clientContractId}',
  getClientComponentsAndPrice:
    '/api/client-contract/components-and-price?clientContractId=#{clientContractId}',

  // Chat API endpoints
  queryUserRequest: '/api/user/query',

  getReportConfigDetails:
    '/api/client-contract/report-config?clientContractId=#{clientContractId}&type=#{type}',
  getClientRequirementListDetails:
    '/api/client-requirement/client-requirement-list-by-contract-id?clientContractId=#{clientContractId}',
  updateClientRequirementList:
    '/api/client-contract/client-requirement-list/#{clientContractId}',
  getAllAttributeTypeIds: '/api/client-contract/attribute-type-ids',
  getAllDocumentTypeIds: '/api/client-contract/document-type-ids',
  updateClientContractStatus:
    '/api/client-contract/update/status?clientContractId=#{clientContractId}',
  getClientContractDropdownData: '/api/client-contract/dropdown',
  getRuleDefinitionEditData: '/api/client-contract/rule-definition-edit-data',
  getAdditionalDocVerificationDropdownData:
    '/api/client-contract/additional-doc-verification-dropdown',
  updateClientContract:
    '/api/client-contract/update?clientContractId=#{clientContractId}',
  updateClientContractReportConfig:
    '/api/client-contract/update-report-config?clientContractId=#{clientContractId}&type=#{type}',
  duplicateClientContract:
    '/api/client-contract/duplicate?clientContractId=#{clientContractId}',
  deleteBaseComponent:
    '/api/client-contract/delete-base-component?clientContractId=#{clientContractId}',
  deleteAllowedComponentOrBundle:
    '/api/client-contract/delete-allowed-component-or-bundle?clientContractId=#{clientContractId}',
  updateComponentPricing:
    '/api/client-contract/update-component-pricing?clientContractId=#{clientContractId}',
  updateClientContractBundleConfig:
    '/api/client-contract/create-or-update?clientContractId=#{clientContractId}',
  addComponentToContract:
    '/api/client-contract/add-component?clientContractId=#{clientContractId}',
  updateAddonConfig:
    '/api/client-contract/update-addon-config?clientContractId=#{clientContractId}',
  getDuplicateDetectionPolicy:
    '/api/client-contract/duplicate-detection-policy?clientContractId=#{clientContractId}',
  updateDuplicateDetectionPolicy:
    '/api/client-contract/update-duplicate-detection-policy?clientContractId=#{clientContractId}',
  getAddonConfigOptions:
    '/api/client-contract/addon-config-options?clientContractId=#{clientContractId}',
  updateClaim: '/api/validation/update-claim',
  updateLOAInsufficiency: '/api/validation/loa-insufficiency',
  addNewIa: '/api/validation/add-new-ia',
  getEducationDetails: '/api/education-details?synonym=#{synonym}',
  assignReview:
    '/api/validation/assign-review?verificationRequestId=#{verificationRequestId}',
  processRequest: '/api/validation/process-request?caseId=#{caseId}',
  getComponentDocument:
    '/api/validation/component-document?componentId=#{componentId}',
  updateFollowUp: '/api/followUp-case-details/update',
  searchIaOffice: '/api/validation/search-ia-offices?query=#{query}',
  getIaOfficeById: '/api/validation/ia-office',
  getIaOfficeByIdForCaseEntry: '/api/case-entry/ia-office',
  getEmailVerifierComponentIdDetailsWithCaseId: `/api/initiate-verification/claim-case-details/#{parentCaseId}/#{caseId}?telescopicAccessType=#{telescopicAccessType}`,
  getVerifierDetailsForInitiationScreen: `/api/initiate-verification/verifier-for-initiation-screen`,
  getEmailVerifierComponentIdDetails: `/api/initiate-verification/claim-details?caseId=#{caseId}&dependentWorkflowId=#{dependentWorkflowId}&purpose=#{purpose}`,
  getFollowUpCaseDetails: `/api/followUp-case-details?caseId=#{caseId}`,
  getFollowUpCaseDetailsWithDependency: `/api/followUp-case-details?caseId=#{caseId}&requestedDependencyId=#{requestedDependencyId}`,
  getFollowUpCaseDependecyIds: `/api/followUp-case-details/getDependencyIds?followUpCaseId=#{followUpCaseId}`,
  getVendorFollowUpCaseDetails: `/api/followUp-case-details/vendor?caseId=#{caseId}`,
  getVerifierApplicantDetailsByClaim: `/api/initiate-verification/applicant-details?claimItemId=#{id}`,
  getVerifierApplicantDetailsByCaseId: `/api/initiate-verification/applicant-details?caseId=#{caseId}`,
  getVerifierApplicantDetailsByDuplicateClaimItemId: `/api/initiate-verification/applicant-details?caseId=#{caseId}&duplicateCaseId=#{duplicateCaseId}`,
  getIssuingAuthorityAggregatorsOptions: `/api/initiate-verification/issuing-authority-aggregator`,
  getVerifierApplicantDetailsByToken: `/api/initiate-verification/bulk-applicant-details?token=#{id}&activeClaimItemId=#{activeClaimItemId}`,
  getApplicantPersonalInfo: `/api/initiate-verification/user-details?claimItemId=#{claimItemId}`,
  emailVerificationReInitiate: `/api/initiate-verification/verification-follow-up-initiate/#{parentCaseId}?telescopicAccessType=#{telescopicAccessType}`,
  emailVerificationInitiate: `/api/initiate-verification/verification-initiate`,
  verificationEmailSent: `/api/initiate-verification/update-verification-email?caseId=#{caseId}&telescopicAccessType=#{telescopicAccessType}&parentCaseId=#{parentCaseId}`,
  updateClaimVerificationCommunicationRequest:
    '/api/initiate-verification/update-initiated-request',
  getHighRiskPageDetails: `/api/initiate-verification/high-risk-page-details?caseId=#{caseId}`,
  submitHighRiskResponse: `/api/initiate-verification/submit-high-risk-response`,
  emailVerifierResponse: `/api/initiate-verification/verifier-response`,
  submitVerifierRequest: `/api/initiate-verification/submit-verifier-request?caseId=#{caseId}`,
  submitVerifierResponse: `/api/initiate-verification/submit-verifier-response`,
  submitVerifierForApproval: `/api/initiate-verification/submit-verifier-for-approval`,
  getIssuingAuthorityRequiredData: `/api/initiate-verification/issuing-authority-required-data/#{claimItemId}`,
  getReportDetails: `/api/report/detail?caseId=#{caseId}`,
  getReportTranlatorPageDetails: `/api/document-translation/detail?caseId=#{caseId}`,
  fetchReportQRCode: `/api/document-translation/fetch-report-qrcode?caseId=#{caseId}&reportType=#{reportType}`,
  getBulkUpdateTableData: `/api/ia-payout/upload-bulk-update-document`,
  getReportDetailsForPolling: `/api/report/polling-detail`,
  getFilterOptions: `/api/pending-claims/getFilterOptions`,
  publishReport: `/api/report/publish`,
  addReportResponse: `/api/report/reportqc-response`,
  postBatchDocumentsForTranslation: `/api/translate/document-translate/batch`,
  postDocumentsForTranslation: `/api/translate/document-translate`,
  updateDocumentTranslation: `/api/translate/document-translate`,
  getDocumentTranslation: `/api/translate/document-translate?originalDocumentId=#{originalDocumentId}`,
  postReportTranslate: `/api/report/report-translate`,
  updateReportTranslation: `/api/report/report-translate-update`,
  uploadClaimProofURL: `/api/validation/upload-claim-proof?verificationRequestId=#{verificationRequestId}`,
  getQualityCheckDetails: `/api/verifier/qc-details?caseId=#{caseId}`,
  getReportApprovalDetails: `/api/report-approval/details?caseId=#{caseId}`,
  getReportApprovalPendingCases: `/api/report-approval/pending-cases`,
  postReportApprovalDecision: `/api/report-approval/decision`,
  addQualityRemarksDetails: `/api/verifier/qc-update?caseId=#{caseId}`,
  getSsoLoginUrl: '/api/ops/ssoLoginUrl?redirectUrl=#{redirectUrl}',
  ssoLogin: '/api/ops/ssoLogin?code=#{code}&redirectUrl=#{redirectUrl}',
  ssoLogOutUrl: `/api/ops/ssoLogOut`,
  getOpsUserByUserId: `/api/ops/getOpsUserByUserId?opsUserId=#{opsUserId}`,
  notifications: '/api/notifications',
  updateReadStatus: '/api/notifications/updateReadStatus',
  notificationsStatus: '/api/notifications/getNotificationsStatus',
  getClientContractingEntities:
    '/api/create-client/getClientContractingEntities',
  getCountries: '/api/location/country',
  getStates: '/api/location/state',
  getCities: '/api/location/city',
  getMultiCountriesStates:
    '/api/location/multi-country-state?countryIds=#{countryIds}',
  getMultiStateCountryCities:
    '/api/location/multi-state-city?countryIds=#{countryIds}&stateIds=#{stateIds}',
  getNationalitiesConfig: '/api/config/nationalities',
  createClient: '/api/create-client/',
  getValidationBreadCrumbs:
    '/api/validation/breadcrumbs?verificationRequestId=#{verificationRequestId}',
  getVerificationBreadCrumbs:
    '/api/verification-details/breadcrumbs?claimItemId=#{claimItemId}',
  getAllClientTnfo: '/api/client-management/get-all-clients',
  searchPartners: '/api/partner-onboarding/search-partners',
  getIaDetails:
    '/api/create-vendor/get-ia-details?iaName=#{iaName}&authorityType=#{authorityType}',
  getModeOfPaymentOptions: '/api/create-vendor/mode-of-payment-options',
  createVendor: '/api/create-vendor/create',
  editVendor: '/api/create-vendor/edit?vendorId=#{vendorId}',
  createPartner: '/api/partner-onboarding/create-partner',
  updatePartner:
    '/api/partner-onboarding/partner-details?partnerId=#{partnerId}',
  getPartnerVerificationScope: '/api/partner-onboarding/client-contract',
  getPartnerType: '/api/partner-onboarding/partner-type',
  getIaListDetailsByName: `/api/ia-selection/list?name=#{name}&iaStatus=#{iaStatus}`,
  getVendorDatabase: '/api/vendor/getAllVendors',
  getIaSectionAttributes: `/api/issuing-authority-map/get-section-attributes?issuingAuthorityId=#{issuingAuthorityId}&componentTypeId=#{componentTypeId}`,
  getIssuingAuthorityTabsDetails: `/api/issuing-authority-map/ia-info-details?caseId=#{caseId}&telescopicAccessType=#{telescopicAccessType}`,
  getIssuingAuthorityOfficeTabsDetails: `/api/issuing-authority-map/ia-info-details?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIssuingAuthorityAprrovalData: `/api/issuing-authority-approval/ia-details?caseId=#{caseId}`,
  getIssuingAuthorityCommentslData: `/api/issuing-authority-approval/ia-comments?caseId=#{caseId}`,
  fetchIaUpdateDetails: `/api/issuing-authority-update/fetch-ia-section-details`,
  toggleIaEntityStatus: `/api/issuing-authority-update/toggle-status`,
  toggleIaAffiliationStatus: `/api/issuing-authority-update/update-affiliation-status`,
  getIssuingAuthorityUpdateAttributeOptionsDetails: `/api/issuing-authority-map/get-update-attributes?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&currentTab=#{currentTab}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}&telescopicAccessType=#{telescopicAccessType}`,
  getIssuingAuthorityAttributeAdditionalDetails: `/api/issuing-authority-map/get-additional-details?componentType=#{componentType}&industry=#{industry}&type=#{type}`,
  searchMatchedIssuingAuthority: `/api/issuing-authority-map/search?iaAddressId=#{iaAddressId}&caseId=#{caseId}`,
  searchMatchedIssuingAuthorityResult: `/api/issuing-authority-map/search-ia?synonym=#{synonym}&caseId=#{caseId}`,
  deleteMRl: `/api/issuing-authority-update/delete-mrl`,
  deleteComponent: `/api/issuing-authority-update/delete-component`,
  deleteVerifierDetails: `/api/issuing-authority-update/delete-verifier-details`,
  deleteIAPaymentDetails: `/api/issuing-authority-update/delete-payment-details`,
  deleteIAInitiationDetails: `/api/issuing-authority-update/delete-initiation-details`,
  deleteIAPastProof: `/api/issuing-authority-update/delete-past-proof-details`,
  deleteIASynonym: `/api/issuing-authority-update/delete-synonym`,
  getIaAdditionalList: `/api/issuing-authority-map/issuing-authority-additional-list?issuingAuthorityId=#{issuingAuthorityId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIaDegreeList: `/api/issuing-authority-map/get-degree-List?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}`,
  getIaAffiliationList: `/api/issuing-authority-map/affiliation-List?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIaSuspiciousList: `/api/issuing-authority-map/issuing-authority-suspicious-list?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}`,
  getAllVerifier: `/api/issuing-authority-map/issuing-authority-verifier-list?issuingAuthorityId=#{issuingAuthorityId}&officeId=#{officeId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}`,
  getAllVerifierWithClaimId: `/api/issuing-authority-map/issuing-authority-verifier-list-from-claimid?claimId=#{claimId}`,
  getAllMRL: `/api/issuing-authority-map/issuing-authority-component-mrl-list?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}`,
  getAllComponentMapping: `/api/issuing-authority-map/issuing-authority-component-mapping-list?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}`,
  getIaPaymentFees: `/api/issuing-authority-map/issuing-authority-payment-fees?issuingAuthorityId=#{issuingAuthorityId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIaPaymentAccountDetails: `/api/issuing-authority-map/issuing-authority-payment-account-details?caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getInitialConfiguration: `/api/issuing-authority-map/issuing-authority-intial-configuration?issuingAuthorityId=#{issuingAuthorityId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  // IAO Verification Initiation List (Cover Letter Configuration)
  getVerificationConfigurationList: `/api/issuing-authority-database/issuing-authority-verification-configuration-list?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getPassportConfiguration: `/api/issuing-authority-map/passport-configuration?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  createVerificationConfiguration: `/api/issuing-authority-map/iao-verification-initiation-list`,
  updateVerificationConfiguration: `/api/issuing-authority-map/iao-verification-initiation-list/#{id}`,
  deleteVerificationConfiguration: `/api/issuing-authority-map/delete-verification-configuration`,
  updateVerifierStatus: `/api/issuing-authority-map/update-verifier-status`,
  getIaPastProof: `/api/issuing-authority-map/ia-past-proof?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}`,
  getIaPastOffice: `/api/issuing-authority-map/ia-past-address-list?issuingAuthorityId=#{issuingAuthorityId}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIaPastNames: `/api/issuing-authority-map/ia-past-names?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIaSynonyms: `/api/issuing-authority-map/ia-synonyms?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getActiveIaSynonymsAndPastName: `/api/issuing-authority-map/active-ia-synonyms-and-past-name?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&typeQuery=#{typeQuery}`,
  getIaTranslations: `/api/issuing-authority-map/ia-translations?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  translateIaOfficeText: `/api/issuing-authority-map/translate-ia-office-text`,
  deleteIATranslation: `/api/issuing-authority-update/delete-translation`,
  mapNewIaDetailsComponent: `/api/issuing-authority-map/map-new-ia`,
  getIaOverviewInfo: `/api/issuing-authority-map/get-ia-overview-info?issuingAuthorityId=#{issuingAuthorityId}&caseId=#{caseId}&iaCreationFlowType=#{iaCreationFlowType}&issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  updateIssuingAuthorityDetails: `/api/issuing-authority-update/update-ia-details?telescopicAccessType=#{telescopicAccessType}`,
  getPlaceAutocomplete: '/api/location/place-autocomplete?query=#{query}',
  getPlaceDetails: '/api/location/place',
  validatePlaceDetails: '/api/location/validate',
  getIaPayoutCaseDetails: '/api/ia-payout/get-case-details?caseId=#{caseId}',
  getRefundPayoutCaseDetails: '/api/ia-payout/get-refund-case-details',
  getRefundPayoutCaseDetailsById:
    '/api/ia-payout/get-refund-case-details/#{caseId}',
  updatePayoutReceipt: '/api/ia-payout/payout-proof/#{caseId}',
  updateIaPayoutCaseDetails: '/api/ia-payout/update-payout-details',
  updateSingleIaPayoutCaseDetails:
    '/api/ia-payout/update-single-payout-details?caseId=#{caseId}',
  updateRefundPayoutCaseDetails:
    '/api/ia-payout/update-refund-payout-details?caseId=#{caseId}',
  createRefundPayoutCaseDetails:
    '/api/ia-payout/create-refund-payout?caseId=#{caseId}',
  downloadBulkUpdateCSV:
    '/api/ia-payout/download-payout-csv?payoutType=#{payoutType}&paymentMode=#{paymentMode}',
  getIaDashboardDetails: `/api/ia-dashboard/details?type=#{type}&searchText=#{searchText}`,
  getIaResearchList: `/api/ia-dashboard/ia-list`,
  getIsIaUpdateAllowed: `/api/issuing-authority-map/issuing-authority-update-allowed?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getFinanceList: `/api/finance-dashboard/finance-list?from=#{from}&to=#{to}&tableType=#{tableType}`,
  getFinanceOveriviewMetrics: `/api/finance-dashboard/finance-dashboard-metrics?from=#{from}&to=#{to}`,
  getFinanceOtherMetrics: `/api/finance-dashboard/finance-dashboard-bars?barType=#{barType}`,
  getFinanceLedgerFilters: `/api/finance-ledger/filters?tab=#{tab}`,
  getFinanceLedgerTableData: `/api/finance-ledger/filter/#{tab}`,
  getFinanceLedgerColumns: `/api/finance-ledger/columns?tab=#{tab}`,
  getProductAnomalyTabs: `/api/product-anomaly-dashboard/tabs`,
  getProductAnomalyTabContent: `/api/product-anomaly-dashboard/tab-content`,
  getProductAnomalyMetricValue: `/api/product-anomaly-dashboard/metric-value`,
  getProductAnomalyTableColumns: `/api/product-anomaly-dashboard/table/columns`,
  getProductAnomalyTableRecords: `/api/product-anomaly-dashboard/table/records`,
  closeIaApprovalCase: '/api/issuing-authority-approval/close-case',
  getAllocationTaskWithSubordinates: `/api/task-allocation/get-task-with-users`,
  getAllocationTaskWithEmailAndCase: `/api/task-allocation/get-task-with-email-case?searchText=#{searchText}`,
  getAllocationTask: `/api/task-allocation/get-task/#{userId}`,
  updateAssigneeOfTaskByEmail: `/api/task-allocation/allocate-task-by-email`,
  reinitiateVerification:
    '/api/initiate-verification/reinitiate-verification?caseId=#{caseId}',
  generateEmail: '/api/initiate-verification/auto-generate-email',
  sendEmailVerification:
    '/api/initiate-verification/send-email-verification?caseId=#{caseId}',
  getIAPayoutRequired:
    '/api/initiate-verification/ia-payout-required/#{caseId}?telescopicAccessType=#{telescopicAccessType}&parentCaseId=#{parentCaseId}',
  updateIaRequestedDetails:
    '/api/issuing-authority-update/update-ia-requested-details',

  getVerificationDocumentByCaseId:
    '/api/initiate-verification/verification-document-by-claimId?caseId=#{caseId}',
  getCaseHistoryTimeline:
    '/api/get-case-history?caseId=#{caseId}&entityId=#{entityId}',
  getAuditCases:
    '/api/audit/get-audit-cases?searchText=#{searchText}&type=#{type}',
  trackCases: '/api/track-cases',
  translateObjectsList: '/api/translate/objects-list',
  translateDocumentsList: '/api/translate/documents-list',
  getIndividualMetrics: `/api/analytics-individual-ops/`,
  getIndividualPerformanceRadialBarData: `/api/analytics-individual-ops/radial-bar`,
  getIACreationOverview: `/api/analytics-individual-ops/ia-creation-overview`,
  getReportQCOverview: `/api/analytics-individual-ops/report-qc-overview`,
  getVerificationQCOverview: `/api/analytics-individual-ops/verification-qc-overview`,
  getInsufficiencyCaseOverview: `/api/analytics-individual-ops/insufficiency-case-overview`,
  getIndividualAverageCompletionTime: `/api/analytics-individual-ops/average-completion-time?from=#{from}&to=#{to}`,
  getIndividualAverageHandlingTime: `/api/analytics-individual-ops/average-handling-time?from=#{from}&to=#{to}`,
  getOpsMetrics: `/api/analytics-ops/`,
  getOpsIaVerificationMetrics: `/api/analytics-ops/ia-verification-metrics`,
  getOpsIAOverview: `/api/analytics-ops/ia-overview`,
  getNumberOfCasesBarsData: `/api/analytics-ops/get-number-of-cases`,
  getBreakdownCasesMetrics: `/api/analytics-ops/breakdown-cases`,
  getAllOpsCaseDetails: `/api/analytics-ops/all-ops-cases?from=#{from}&to=#{to}`,
  getPendingCasesByClient: `/api/analytics-ops/pending-cases-by-client?from=#{from}&to=#{to}`,
  getPendingClaimsByComponenttype: `/api/analytics-ops/pending-claims-by-component?from=#{from}&to=#{to}`,
  getPendingClaimsByClientGeography: `/api/analytics-ops/pending-claims-by-client-geography?from=#{from}&to=#{to}`,
  getPendingCasesByStages: `/api/analytics-ops/pending-cases-by-stages?from=#{from}&to=#{to}`,
  getDashboardPendingClaims: `/api/pending-claims`,
  getDashboardPendingInsufficiencies: `/api/pending-insufficiencies`,
  followUpNowInsufficiency: `/api/pending-insufficiencies/followUpNow?caseId=#{caseId}`,
  updateInsufficiencyComments: `/api/pending-insufficiencies/comments`,
  updateCVCRAsMarkAsReceived: `/api/pending-claims/markResponseReceived?caseId=#{caseId}&type=#{type}`,
  changeFollowUpDate: `/api/pending-claims/changeFollowUpDate?caseId=#{caseId}`,
  getClaimsMetrics: `/api/analytics-ops/claims-metrics?from=#{from}&to=#{to}`,
  getCompletedCasesDistribution: `/api/analytics-ops/completed-cases-distribution?from=#{from}&to=#{to}`,
  getDownloadReportUrl: `/api/analytics-ops/download-report?metricId=#{metricId}&from=#{from}&to=#{to}`,
  getAllValidationProcess: `/api/analytics-ops/all-validation-process?from=#{from}&to=#{to}`,
  getAllTeamMembersData: `/api/analytics-ops/all-team-members?opsId=#{opsId}&tableType=#{tableType}&from=#{from}&to=#{to}`,
  getAllTeamPerformanceTableData: `/api/analytics-team-ops/all-team-members?opsId=#{opsId}&tableType=#{tableType}&from=#{from}&to=#{to}&processName=#{processName}&processId=#{processId}`,
  getPermissibleProcess: `/api/analytics-team-ops/get-permissibleProcesses`,
  getGeographyAnalysis: `/api/analytics-ops/geography-analysis?from=#{from}&to=#{to}`,
  getOpsOverflowMetrics: `/api/analytics-ops/overflow-metric`,
  getOpsNumberOfCasesMetricData: `/api/analytics-ops/numberofcases-metric`,
  getOpsProcessMetrics: `/api/analytics-ops/process-specific-metrics`,
  getOpsEndToEndProcessing: `/api/analytics-ops/end-to-end-preocessing-data`,
  getOpsInsufficiencyTable: `/api/analytics-ops/insufficiency-table?tableId=#{tableId}`,
  getOpsInsufficienciesMetrics: `/api/analytics-ops/insufficiency-metrics?from=#{from}&to=#{to}`,
  getTeamOverviewMetrics: `/api/analytics-team-ops/team-performance-overview?from=#{from}&to=#{to}&processName=#{processName}&processId=#{processId}`,
  getOpsValidationRadialData: `/api/analytics-ops/radial-bar?from=#{from}&to=#{to}`,
  getOpsValidationAccuracyRadialData: `/api/analytics-ops/accuracy/radial-bar?from=#{from}&to=#{to}`,
  getTeamPerformanceAccuracyRadialData: `/api/analytics-team-ops/radial-bar?from=#{from}&to=#{to}&processName=#{processName}&processId=#{processId}`,
  getAllClients: `/api/client-management/get-all-clients`,
  getCasesTableData: `/api/track-cases/filter/verification-cases`,
  getTotalTasksCompletedTable: `/api/analytics-individual-ops/total-tasks-table?from=#{from}&to=#{to}`,
  getTotalTasksAssignedTable: `/api/analytics-individual-ops/total-tasks-assigned-table?from=#{from}&to=#{to}`,
  getRejectedTasksTable: `/api/analytics-individual-ops/rejected-tasks-table?from=#{from}&to=#{to}`,
  getIAProactiveTable: `/api/analytics-individual-ops/ia-proactive-table`,
  getIAReactiveTable: `/api/analytics-individual-ops/ia-reactive-table`,
  getFilterForIndividualOps: `/api/analytics-individual-ops/filter`,
  getReportQCTasksTable: `/api/analytics-individual-ops/report-qc-tasks-table`,
  getTeamTotalTasksCompletedTable: `/api/analytics-team-ops/team-total-tasks-table?from=#{from}&to=#{to}&processName=#{processName}&processId=#{processId}`,
  getVerificationQCTasksTable: `/api/analytics-individual-ops/verification-qc-tasks-table`,
  getInsufficiencyCaseTasksTable: `/api/analytics-individual-ops/insufficiency-case-tasks-table`,
  getTeamMembersDetailTable: `/api/analytics-team-ops/team-members-detail-table?from=#{from}&to=#{to}&processName=#{processName}&processId=#{processId}`,
  getTasksTableData: `/api/track-cases/filter/tasks`,
  getClaimsTableData: `/api/track-cases/filter/claim-cases`,
  getFilterForTrackCases: `/api/track-cases/filters?filterType=#{filterType}&restrictToUserClients=#{restrictToUserClients}`,
  getCDMDashboardOverview: `/api/insight-dashboard/overview`,
  getCDMDashboardDetailData: `/api/insight-dashboard/detail-data`,
  getCDMDashboardFilters: `/api/insight-dashboard/filters?restrictToUserClients=#{restrictToUserClients}`,
  getHealthCheckupOverview: `/api/insight-dashboard/health-checkup-overview`,
  getProcessesByClientId: `/api/insight-dashboard/processes?clientId=#{clientId}`,
  getVerificationManagerRegionOverview: `/api/verification-manager-dashboard/region-overview`,
  getVerificationManagerRegionDetail: `/api/verification-manager-dashboard/region-detail`,
  getVerificationManagerMetrics: `/api/verification-manager-dashboard/metrics`,
  getVerificationManagerHealthCheck: `/api/verification-manager-dashboard/verification-health-check`,
  getVerificationManagerModeOfVerification: `/api/verification-manager-dashboard/mode-of-verification`,
  getVerificationManagerFilters: `/api/verification-manager-dashboard/filters`,
  getVerificationManagerMetricRedirects: `/api/verification-manager-dashboard/metric-redirects`,
  getFiltersForMyDashboard: `/api/initiate-verification/filters`,
  getFiltersForVerificationCases: `/api/initiate-verification/filters/verifications`,
  getIaNames: `/api/track-cases/get-ia-names?iaName=#{iaName}`,
  getPartnerOrgNames: `/api/track-cases/get-partner-org-names?name=#{name}`,
  getStateList: `/api/track-cases/get-state-list?countries=#{countries}`,
  getCityList: `/api/track-cases/get-city-list?countries=#{countries}&states=#{states}`,
  getPreviousComments:
    '/api/previous-comments/get-previous-comments?claimId=#{claimId}',
  getReportPreviousComments: '/api/report/previous-comments?claimId=#{claimId}',
  getReportDraftComments: '/api/report/draft-comments?claimId=#{claimId}',
  getAllClaimRejectionSummary: '/api/report/fetch-bulk-draft-comments',
  getValidatorPreviousComments:
    '/api/validation/get-previous-comments?claimId=#{claimId}',
  utvFormSubmit: '/api/applicant-followup/submit-utv?caseId=#{caseId}',
  submitClaimUtv: '/api/validation/submit-claim-utv',
  unAssignTask: '/api/user/unassign-task',
  skipTask: `/api/task-allocation/skip-task`,
  getPartnerDetails: `/api/partner-onboarding/partner-details?partnerId=#{partnerId}&isEditFlow=#{isEditFlow}`,
  updateClient: '/api/client-management?clientId=#{clientId}',
  getClientDetails: `/api/client-management/client-details?clientId=#{clientId}`,
  getClientLevelConfig: `/api/client-management/client-level-config?clientId=#{clientId}`,
  getCreateClientDetails: `/api/client-management/create-client?clientId=#{clientId}`,
  createClientUser: '/api/client-management/client-user?clientId=#{clientId}',
  updateClientUser: '/api/client-management/client-user',
  reInviteClientUser: '/api/client-management/client-user/re-invite',
  getClientUserById: '/api/client-management/client-user/#{clientUserId}',
  deleteClientuser: '/api/client-management/client-user',
  getCreatePartnerDetails: `/api/partner-onboarding/create-partner`,
  errorLog: '/api/log',
  updateReVerificationInvocationData:
    '/api/verifier/update-re-verification-invocation?reVerificationInvocationId=#{reVerificationInvocationId}&caseId=#{caseId}',
  createPartnerUser: '/api/partner-onboarding/partner-user',
  updatePartnerUser: '/api/partner-onboarding/partner-user',
  reInvitePartnerUser: '/api/partner-onboarding/partner-user/re-invite',
  getPartnerRoles: '/api/settings-partner/roles',
  updateVendorUser: '/api/vendor/vendor-user',
  reInviteVendorUser: '/api/vendor/vendor-user/re-invite',
  getCaseHistoryOfVR:
    '/api/verification-details/case-history?verificationRequestId=#{verificationRequestId}',
  getCaseHistoryOfEntity:
    '/api/entity-details/entity-history?entityId=#{entityId}',
  updateLatestPartnerAdminResponse:
    '/api/verification-details/update-latest-partner-admin-response/#{verificationRequestId}',
  getIssuingAuthorityDetails:
    '/api/issuing-authority-database/ia-info-details?issuingAuthorityId=#{issuingAuthorityId}',
  getIssuingAuthorityOfficesDetails:
    '/api/issuing-authority-database/ia-info-details/offices?issuingAuthorityId=#{issuingAuthorityId}',
  getIssuingAuthorityOfficesEntities:
    '/api/issuing-authority-database/ia-info-details/offices/entities?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}&entityTypes=#{entityTypes}',
  bulkUpdateIaGlobalRanking:
    '/api/issuing-authority-database/ia-info-details/offices/global-ranking/bulk-upload',
  getIssuingAuthorityEntityAuditTrailDetails:
    '/api/issuing-authority-database/ia-info-details/ia-audit-trail?issuingAuthorityEntityId=#{issuingAuthorityEntityId}&issuingAuthorityEntityType=#{issuingAuthorityEntityType}',
  getIssuingAuthorityOfficesDetailsById:
    '/api/issuing-authority-database/ia-info-details/offices/#{issuingAuthorityOfficeId}',
  updatePastCases: '/api/validation/modify-past-cases',
  createOverlapsWithPastCases:
    '/api/validation/create-overlaps-with-past-cases',
  assignAndFrontload: '/api/dashboard-ops/assign-and-frontload',
  getMatchComponentsRTTabs:
    '/api/validation/match-components-rt-tabs?tabId=#{tabId}&caseId=#{caseId}',
  createMatchComponentsRT: '/api/validation/match-components-rt',
  getFillComponentsRTTabs:
    '/api/validation/fill-components-rt-tabs?tabId=#{tabId}&caseId=#{caseId}&isLastTabId=#{isLastTabId}',
  updateFillComponentRTTab:
    '/api/validation/fill-components-rt-tabs?caseId=#{caseId}',
  getclientcontractslist: '/api/client-contract/list?clientId=#{clientId}',
  reInviteApplicant: '/api/invite-applicant/re-invite',
  getVerificationDetailsByCaseId:
    '/api/verification-details/verification-details-by-case-id?caseId=#{caseId}&fetchApplicant=#{fetchApplicant}',
  getVerificationDetailsById: `/api/verification-details/verification-request/#{verificationId}?fetchApplicant=#{fetchApplicant}`,
  getWorkflowStageHistory: `/api/verification-details/workflow-stage-history?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}&endTimeStamp=#{endTimeStamp}`,
  cancelVerification: '/api/verification-creation/cancel',
  getRefundPayoutsByVRId:
    '/api/payments/get-refund-by-vr/#{verificationRequestId}',
  getPaymentPackageDetailsFromVR: `/api/verification-details/get-payment-package-details/#{verificationRequestId}`,
  startVerification: '/api/verification-initiation/verification/start',
  getPreviousReportFiles:
    '/api/verification-details/previous-reports/#{verificationRequestId}',
  getDepartmentAndCourse:
    '/api/validation/department-and-course?iaOfficeId=#{iaOfficeId}&claimItemId=#{claimItemId}',
  updateVerificationResponseRemarks: '/api/verifier/update-remarks',
  updateVerificationResponseRemarksInReport: '/api/report/update-remarks',
  getReportStatusData: '/api/report/report-status?reportId=#{reportId}',
  regenerateReport: '/api/report/regenerate-report',
  updateAnnexureSelection: '/api/report/modify-annexure-selection',
  publishDownloadDocumentAudit:
    '/api/verification-details/publish-download-document-audit',
  getSubmitterDetails:
    '/api/case-entry/submitter?verificationRequestId=#{verificationRequestId}',
  postCaseEntry: '/api/case-entry',
  getMrl:
    '/api/verification-mrl?officeId=#{officeId}&componentId=#{componentId}&applicantUserId=#{applicantUserId}',
  getInsufficiency:
    '/api/case-entry/insufficiency?verificationRequestId=#{verificationRequestId}',
  // Component comparison
  getComponentAttributesComparisonValidation:
    '/api/validation/compare-component-attributes?componentId1=#{componentId1}&componentId2=#{componentId2}',
  getComponentAttributesComparisonVerification:
    '/api/initiate-verification/compare-component-attributes?componentId1=#{componentId1}&componentId2=#{componentId2}',
  getComponentAttributesComparisonQC:
    '/api/verifier/compare-component-attributes?componentId1=#{componentId1}&componentId2=#{componentId2}',
  getComponentAttributesComparisonReportQC:
    '/api/report/compare-component-attributes?componentId1=#{componentId1}&componentId2=#{componentId2}',
  compareEditedVerificationResponse:
    '/api/initiate-verification/compare-edited-verification-response',
  getKVPairConfig: '/api/kvpair-config/get-kvpair-configs',
  createKVPairConfig: '/api/kvpair-config/create-kvpair-configs',
  updateKVPairConfig: '/api/kvpair-config/update-kvpair-configs',
  getCaseCreationDeatils:
    '/api/verification-creation/get-case-creation/?verificationRequestId=#{verificationRequestId}',
  getS3DocumentUrls: `/api/verification-creation/pre-signed-urls?fileIds=#{fileIds}`,
  getVDTabContent:
    '/api/verification-details/ops/tabs/#{tabKey}?verificationRequestId=#{verificationRequestId}',
  getVDTabContentByCaseId:
    '/api/verification-details/ops/tabs/#{tabKey}?caseId=#{caseId}',
  getVDInsufficiency:
    '/api/verification-details/ops/insufficiency?verificationRequestId=#{verificationRequestId}',
  getVDInsufficiencyByCaseId:
    '/api/verification-details/ops/insufficiency?caseId=#{caseId}',
  getVDTabConfig:
    '/api/verification-details/ops/tab-config?verificationRequestId=#{verificationRequestId}',
  getVDTabConfigByCaseId:
    '/api/verification-details/ops/tab-config?caseId=#{caseId}',
  getVDCaseHistoryStageDetail:
    '/api/verification-details/ops/case-history-stage-detail?entityId=#{entityId}&workflowStage=#{workflowStage}&startTimeStamp=#{startTimeStamp}',
  getVDBirdEyeViewByCaseId:
    '/api/verification-details/ops/bird-eye-view?caseId=#{caseId}',
  getIAResponseStatusMetrics: '/api/ia-response-metrics?duration=#{duration}',
  getIAComponentTypes: '/api/ia-response-metrics/component-types',
  getIAResponseDetailList:
    '/api/ia-response-metrics/detail-list?duration=#{duration}&responseDays=#{responseDays}',
  getIALocationOptions: '/api/ia-response-metrics/location-options',
  getIaInsights: `/api/ia-insights?issuingAuthorityOfficeId=#{issuingAuthorityOfficeId}`,
  getIaResearchDashboardOverview: '/api/ia-research-dashboard/overview',
  getIaResearchDashboardHealthCheckup:
    '/api/ia-research-dashboard/health-checkup',
  getIaResearchDashboardDetailData: '/api/ia-research-dashboard/detail-data',
  cancelInsufficiency: '/api/validation/cancel-insufficiency',
  postCaseInternalComment: `/api/case-internal-comment`,
  getInsufficiencyReviewDetails: `/api/insufficiency-review/details?caseId=#{caseId}`,
  updateInsufficiencyReview: `/api/insufficiency-review/#{reviewId}`,
  updateInsufficiencyReviewComment: `/api/insufficiency-review/comment/#{entityId}`
} as const;

export const TEAM_MEMBER_ID = 'teamMemberId';
export const TEAM_MEMBERS_API = {
  getAllTeamMembers: '/api/team-member',
  getMetadata: '/api/team-member/metadata',
  getTeamMemberById: `/api/team-member/:${TEAM_MEMBER_ID}`,
  getTeamMemberByIdWithManager: `/api/team-member/#{${TEAM_MEMBER_ID}}?manager=true`,
  deleteMemberById: `/api/team-member/:${TEAM_MEMBER_ID}`,
  updateMemberById: `/api/team-member/:${TEAM_MEMBER_ID}`,
  createTeamMember: `/api/team-member`,
  getManagerList: '/api/team-member/manager',
  getIA:
    '/api/team-member/ia?synonym=#{synonym}&authorityType=#{authorityType}',
  updateAvailabilityStatus: '/api/team-member/availability-status'
};

export const ACCREDITATION_API = {
  getAccreditationFieldData: '/api/accreditation/accreditationFieldData',
  getAccreditationData: '/api/accreditation/getAccreditationData',
  getAccreditationDataPaginated: '/api/accreditation/getAccreditationData',
  postAccreditationData: '/api/accreditation/addAccreditationData',
  getAccreditationDataById:
    '/api/accreditation/getAccreditationDataById?accreditationId=#{accreditationId}',
  getAccreditationDataByQuery:
    '/api/accreditation/getAccreditationData?query=#{query}',
  bulkUpload: '/api/accreditation/bulkUpload'
};

export const IA_ACCREDITATION_API = {
  getIaAccreditationDatabase:
    '/api/ia-accreditation/getIaAccreditationDatabase?searchText=#{searchText}',
  getIAAccreditationMappingData:
    '/api/ia-accreditation/getIAAccreditationMappingData?caseId=#{caseId}',
  postIaAccreditationMappingData:
    '/api/ia-accreditation/postIAAccreditationMappingData',
  postCourseAccreditationData:
    '/api/ia-accreditation/postCourseAccreditationData',
  updateAffiliationData: '/api/ia-accreditation/updateAffiliationData',
  getFilteredComponentsForAccreditation:
    '/api/ia-accreditation/getFilteredComponentsForAccreditation?officeId=#{officeId}',
  createProactiveAccreditation:
    '/api/ia-accreditation/createProactiveAccreditation'
};

export const IA_ACCREDITION_APPROVAL_API = {
  getIaAccreditationApprovalCases:
    '/api/ia-accreditation-approval/getIaAccreditationApprovalCases?searchText=#{searchText}',
  getIaApprovalCaseDetails:
    '/api/ia-accreditation-approval/getIaApprovalCaseDetails?caseId=#{caseId}',
  postIaApprovalDecision:
    '/api/ia-accreditation-approval/postIaApprovalDecision'
};

export const VERIFLOW_LINK = `${process.env.NEXT_PUBLIC_VERIFLOW_LINK}/ProcessPortal/dashboards/VE/Issuing+Authority+Management`;

export const DOCUMENT_UPLOAD_URL = `${process.env.NEXT_PUBLIC_DOCUMENT_SERVICE_URL}/upload`;

export const IA_VENDOR_MAPPING_API = {
  getIAVendorMappingCases: '/api/create-vendor/getIAVendorMappingCases',
  getIaVendorMappingData:
    '/api/create-vendor/getIAVendorMappingData?caseId=#{caseId}',
  updateClaimByVendorDependency:
    '/api/create-vendor/updateClaimByVendorDependency?claimItemId=#{claimItemId}&caseId=#{caseId}',
  mapIaVendor: '/api/create-vendor/mapIaVendor?iaAddressId=#{iaAddressId}',
  rejectVendorMapping: '/api/create-vendor/vendorRejection',
  getDSVComponentType: '/api/create-vendor/dsv-component-types'
};

export const ENTITY_EXPLORER_URL = `/api/entity-explorer?id=#{entityId}`;
export const ADDITIONAL_DOC_VERIFICATION_DROPDOWN_URL =
  '/api/client-contract/additional-doc-verification-dropdown';
export const ENTITY_EXPLORER_REFERECE_URL = `/api/entity-explorer?id=#{entityId}/reference`;

export const VERIFICATION = {
  reassignVendorFollowup: '/api/followUp-case-details/reassignVendorFollowup'
};

export const VERIFICATION_API_URLS = {
  getVerificationOverview: `/api/verification-creation/overview`,
  verificationOverviewPdf: '/api/verification-details/overviewPdf',
  getVerificationOverviewSummary: `/api/verification-details/overview-summary?verificationRequestId=#{verificationRequestId}`,
  getAppealDetails:
    '/api/verification-modification/appeal-details?verificationRequestId=#{verificationRequestId}&caseId=#{caseId}',
  getRequestCorrectionDetails:
    '/api/verification-modification/request-correction-details?verificationRequestId=#{verificationRequestId}&caseId=#{caseId}',
  moveToVerification: '/api/verification-creation/move-to-verification',
  raiseAppealError:
    '/api/verification-modification/raise-appeal-error?subDomain=#{subDomain}',
  replaceClaimItem: '/api/validation/replace-claim-item-v2',
  replaceClaimItemForCaseEntry: '/api/case-entry/replace-claim-item-v2',
  createNewComponentResponseforValidation:
    '/api/validation/create-new-component-response-for-validation',
  saveEditedDocument: '/api/validation/save-edited-document',
  restoreOriginalDocument: '/api/validation/restore-original-document',
  getRestoreOriginalStatus: '/api/validation/restore-original-status',
  sendEditedDocumentNotification:
    '/api/validation/send-edited-document-notification',
  analyseVerificationResponse:
    '/api/initiate-verification/analyse-verification-response',
  getAnalyseVerificationResponseStatus:
    '/api/initiate-verification/get-verification-agent-response/#{verificationAgentAnalysisId}',
  extractProofOfVerificationDocumentData:
    '/api/initiate-verification/initiate-verification-proof-document-extracts',
  getProofOfVerificationDetailsResponse:
    '/api/initiate-verification/get-proof-of-verification-details-response?claimId=#{claimId}',
  updateProofOfVerificationDetailsResponse:
    '/api/initiate-verification/update-proof-of-verification-document-extraction',
  getVerificationAgentAnalysisByClaim:
    '/api/initiate-verification/verification-agent-response-by-claim-item/#{claimItemId}',
  updateVerificationResponse:
    '/api/initiate-verification/verification-agent-analysis/#{verificationAgentAnalysisId}',
  qcAgentAnalysisByClaimItemId:
    '/api/verifier/qc-agent-analysis/filter?claimItemId=#{claimItemId}',
  documentTypeChangeOptions:
    '/api/document-type-change/options?claimItemId=#{claimItemId}',
  documentTypeChangeInitiate: '/api/document-type-change/initiate',
  documentTypeChangeStatus: '/api/document-type-change/#{claimItemId}/status',
  documentTypeChangeApply: '/api/document-type-change/apply',
  documentTypeChangeReject: '/api/document-type-change/reject'
};

export const DATA_TAMPERING_ANALYSIS_API_URLS = {
  dashboardMetrics: `/api/data-tampering-analysis/metrics`,
  listAuditDocs: `/api/data-tampering-analysis/audit-list?confidence_level=#{confidence_level}&status=#{status}&request_app_name=#{request_app_name}&limit=#{limit}&offset=#{offset}`,
  getInferenceResults: `/api/data-tampering-analysis/inference-results?id=#{id}`,
  createAnnotations: `/api/data-tampering-analysis/create-annotations/`
};

export const VERIFICATION_UPLOAD_API_URLS = {
  getComponentsDetailsForCaseEntry:
    '/api/case-entry/components?verificationRequestId=#{verificationRequestId}&filteredComponentTypeIds=#{filteredComponentTypeIds}',
  getAdditionalSteps:
    '/api/verification-creation/additional-components?verificationRequestId=#{verificationRequestId}&isParent=#{isParent}&clientContractId=#{clientContractId}',
  getComponent:
    '/api/verification-creation/component?componentId=#{componentId}&verificationRequestId=#{verificationRequestId}&applicantUserId=#{applicantUserId}',
  componentUrl: '/api/verification-creation/component',
  documentUrl: '/api/verification-creation/document',
  addAdditionalComponent: '/api/verification-creation/additional-components',
  getNameChangeGaps:
    '/api/facet-intelligence/name-change-gaps?verificationRequestId=#{verificationRequestId}',
  getDepartmentCourseByComponentId:
    '/api/verification-creation/get-department-course?componentId=#{componentId}&iaOfficeId=#{iaOfficeId}',
  extractFile:
    '/api/verification-creation/file/extract-attributes?fileId=#{fileId}',
  getClaimDocumentsByVrId:
    '/api/verification-creation/get-claim-documents?verificationRequestId=#{verificationRequestId}'
};

/**
 * Claim Items API URLs
 */
export const CLAIM_ITEMS_API_URLS = {
  getRejectionStageResolution: '/api/claim-items/rejection-stage-resolution'
};

/**
 * Dialer API URLs
 */
export const DIALER_API_URLS = {
  checkAgent: '/api/dialer/check-agent',
  credentials: '/api/dialer/credentials',
  startCall: '/api/dialer/call/start',
  completeCall: '/api/dialer/call/complete',
  callLogs: '/api/dialer/call-logs',
  callLogRecording: '/api/dialer/call-logs/#{id}/recording'
};

/**
 * MIS Report API URLs
 */
export const MIS_REPORT_API_URLS = {
  getReportList: '/api/mis-report/list',
  getReportTypes: '/api/mis-report/report-types',
  downloadReport: '/api/mis-report/download'
};

/**
 * Global Corruption Index (GCI) API URLs.
 * Backed by the Garuda BFF `dashboard-ops` module, route prefix
 * `/global-corruption-index` (client paths are `/api`-prefixed) — Req 2.4, 10.5.
 */
export const GCI_API_URLS = {
  getGciList: '/api/global-corruption-index/list', // POST: { from, size, countrySearch }
  getGciCountryDetail: '/api/global-corruption-index/history/#{countryCode}', // GET
  getGciBulkUpload: '/api/global-corruption-index/bulk-upload',
  getGciBulkUploadTemplate: '/api/global-corruption-index/bulk-upload/template'
} as const;
